import ImageSlot from '../shared/ImageSlot.jsx';
import Reveal from '../shared/Reveal.jsx';
import { useTestimonials } from '../content/useContent.js';

const TONES = {
  white: 'bg-white',
  mint: 'bg-mint',
  // The featured tone is rendered by the large card, but a testimonial can be
  // re-toned in the database while still sitting in the supporting column.
  featured: 'bg-sun',
};

export default function Parents() {
  const { featured: featuredTestimonial, others: testimonials } = useTestimonials();

  return (
    <section id="parents" className="bg-cream pb-24 pt-[86px]">
      <div className="mx-auto max-w-[1240px] px-5 sm:px-8">
        <div className="grid items-stretch gap-[26px] lg:grid-cols-[1.15fr_.85fr]">
          <Reveal className="flex flex-col rounded-[34px] border-[3px] border-forest bg-sun px-6 py-9 shadow-[0_10px_0_rgb(20_83_45_/_0.16)] sm:px-10">
            <p className="font-hand text-[23px] text-gold-text">
              {featuredTestimonial.eyebrow}
            </p>
            <blockquote className="mt-3 text-pretty font-display text-[clamp(24px,2.5vw,36px)] font-bold leading-[1.16] text-forest">
              {featuredTestimonial.quote}
            </blockquote>
            <div className="min-h-[18px] flex-1" />
            <div className="mt-[22px] flex items-center gap-3">
              <div className="size-[46px] flex-none overflow-hidden rounded-full border-[3px] border-forest">
                <ImageSlot shape="circle" name={featuredTestimonial.name} alt="" />
              </div>
              <p className="text-[15px] leading-[1.35]">
                <b>{featuredTestimonial.name}</b>
                <br />
                <span className="text-gold-mute">{featuredTestimonial.detail}</span>
              </p>
            </div>
          </Reveal>

          <div className="flex flex-col gap-[26px]">
            {testimonials.map((item, i) => (
              <Reveal
                key={item.attribution}
                index={i + 1}
                className={`flex-1 rounded-[30px] border-[3px] border-forest px-7 py-6 shadow-[0_9px_0_rgb(20_83_45_/_0.12)] ${TONES[item.tone]}`}
              >
                <p className="text-lg leading-[1.5] text-ink">{item.quote}</p>
                <p className="mt-3 text-sm font-bold text-coral">{item.attribution}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
